import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export function deleteBrand(id: number) {
  return fetchWrapper({
    url: `/api/hardware/brand/${id}`,
    fetchArg: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });
}
